export const BRAND = {
  name: "Kumarasiri Foods",
  phone: "077 329 5077",
  addressLines: ["MEDA, GALATHURA"],
  storageKey: "FOODS",
  invoicePrefix: "KF",
  colors: {
    primary: "#9E1713",
    primaryDark: "#7A120F",
    white: "#FFFFFF",
    chart: ["#9E1713", "#D96560", "#68100D", "#EBA6A3", "#B43B36", "#8A6563", "#4D0B09"],
  },
};
